import './SkeletonText-5cf908c1.css';

var classes = {"SkeletonText":"prc-Skeleton-SkeletonText-o0dUS","SkeletonTextWrapper":"prc-Skeleton-SkeletonTextWrapper-QRoBW"};

export { classes as default };
